import { IsoDate, IsoDateTime, Uuid } from "./global";

export enum TaxYear {
  "2017-18" = "2017-18",
  "2018-19" = "2018-19",
  "2019-20" = "2019-20",
  "2020-21" = "2020-21",
  "2021-22" = "2021-22",
  "2022-23" = "2022-23",
}

export enum Report {
  SA103S = "SA103S",
  SA103F = "SA103F",
  SA105 = "SA105",
  SA105FHL = "SA105FHL",
  SA106 = "SA106",
  SNF = "SNF",
  CATEGORY_SUMMARY = "CATEGORY_SUMMARY",
  PROFIT_LOSS = "PROFIT_LOSS",
  ITSA_ST = "ITSA_ST",
}

export enum StudentLoanPlans {
  planOne = "PLAN 1",
  planTwo = "PLAN 2",
  planFour = "PLAN 4",
  postGrad = "POST GRAD",
}

export type TaxProfile = {
  id: string;
  user: string;
  tax_year: string;
  extra_self_employed_income: number | null; // in pennies
  extra_self_employed_mileage: number | null;
  extra_self_employed_wfh_allowance: number | null;
  extra_self_employed_expenses: number | null;
  student_loan_plan: StudentLoanPlans | null;
  paye_income: number | null;
  paye_months_worked: number | null;
  property_income: number | null;
  property_expenses: number | null;
  personal_allowance: number | null;
  weeks_self_employed: number | null;
};

export type VatType = {
  id: Uuid;
  created_at: IsoDateTime;
  updated_at: IsoDateTime;
  name: string;
  type: "income" | "expenses" | "none_outside_scope";
  is_exempt: boolean;
  description: string;
};

export type VatRate = {
  id: Uuid;
  created_at: IsoDateTime;
  updated_at: IsoDateTime;
  name: string;
  short_name: string;
  short_display_name: string;
  vat_type: VatType;
  percentage: string;
  short_description: string;
  long_description: string;
  meta: Record<string, unknown> | null;
  section: "suggested" | "exact" | "other";
  order: number;
};

export type ExportPeriod = {
  code: string;
  name: string;
  from_datetime: string;
  from_date: string;
  from_date_display: string;
  to_datetime: string;
  to_date: string;
  to_date_display: string;
  summary: string;
};

export type FinancialYear = {
  id: Uuid;
  is_current: boolean;
  year_start: IsoDate;
  year_end: IsoDate;
  additional_income: string | null;
  additional_expenses: string | null;
};
